import BaseService from './base.service'

export default class EquivalenciasService extends BaseService {
    /**
     * Devuelve los grupos de equivalencia.
     * @param codigo si viene, devuelve solo los grupos que contienen ese código
     *               (búsqueda por equivalencia).
     */
    getAll(codigo, fnSuccess, fnError) {
        const query = codigo ? `?codigo=${encodeURIComponent(codigo)}` : '';
        return this.getApi().get(`/equivalencias${query}`)
            .then(response => fnSuccess(response))
            .catch(error => fnError(this.getMessageFromError(error, 'Error al obtener las equivalencias')));
    }

    /**
     * Devuelve el maestro de marcas / proveedores.
     */
    getMarcas(fnSuccess, fnError) {
        return this.getApi().get(`/equivalencias/marcas`)
            .then(response => fnSuccess(response))
            .catch(error => fnError(this.getMessageFromError(error, 'Error al obtener las marcas de equivalencias')));
    }

    /**
     * Devuelve los grupos de equivalencia que contienen el código del artículo.
     */
    getByArticulo(id, fnSuccess, fnError) {
        return this.getApi().get(`/equivalencias/articulo?id=${encodeURIComponent(id)}`)
            .then(response => fnSuccess(response))
            .catch(error => fnError(this.getMessageFromError(error, 'Error al obtener las equivalencias del artículo')));
    }

    /**
     * Crea un grupo de equivalencia.
     * @param codigos array de {marca, codigo}
     */
    create(codigos, observaciones, fnSuccess, fnError) {
        return this.getApi().post(`/equivalencias`, {codigos, observaciones})
            .then(response => fnSuccess(response))
            .catch(error => fnError(this.getMessageFromError(error, 'Error al crear el grupo de equivalencia')));
    }

    /**
     * Reemplaza los códigos y observaciones de un grupo existente.
     */
    edit(id, codigos, observaciones, fnSuccess, fnError) {
        return this.getApi().put(`/equivalencias?id=${id}`, {codigos, observaciones})
            .then(response => fnSuccess(response))
            .catch(error => fnError(this.getMessageFromError(error, 'Error al editar el grupo de equivalencia')));
    }

    /**
     * Elimina un grupo de equivalencia.
     */
    delete(id, fnSuccess, fnError) {
        return this.getApi().delete(`/equivalencias?id=${id}`)
            .then(response => fnSuccess(response))
            .catch(error => fnError(this.getMessageFromError(error, 'Error al eliminar el grupo de equivalencia')));
    }
}
